// Built-in 1x1 cart layout with an unlimited-size tote, injected by the
// worker for every store. It isn't persisted and can't be edited or
// disabled - it exists for shipments that can't fit standard totes.
export const DEFAULT_CART_LAYOUT_ID = 'default-single-tote-unlimited';

export const isDefaultCartLayout = (layout) => layout?.id === DEFAULT_CART_LAYOUT_ID;

export const PACKING_RULE_TYPE_LABELS = {
  generic: 'Generic',
  send_customer_email: 'Send customer email',
  take_picture: 'Take picture',
  add_print_item: 'Add print item',
  print_shipping_label: 'Print shipping label',
  critical_shipping_requirement: 'Critical shipping requirement'
};

export const PACKING_RULE_LEVEL_LABELS = {
  variant: 'Variant',
  product: 'Product',
  collection: 'Collection',
  tag: 'Tag',
  order: 'Order shipment'
};

// Brand palette for custom UI outside Polaris' theme. Semantic colors
// meet WCAG 2.1 AA: >= 4.5:1 as text on white/light surfaces, and >= 4.5:1
// with white text when used as fills. Keep in sync with the --wh-* custom
// properties in index.css.
export const UI_COLORS = {
  warm: '#f4ede9',
  cream: '#f9f2e2',
  warningSurface: '#fbe194',
  ink: '#070808',
  inkSoft: 'rgba(7,8,8,0.6)',
  header: '#124b5f',
  blue: '#1670b5',        // was #1774bb - darkened for AA text contrast
  accent: '#b4610e',      // was #ef8f2f (2.43:1 - failed AA)
  warningText: '#a05421', // was #c66628 - for text on white and orange tints
  success: '#247e64',     // was #2c9c7c (3.41:1 - failed AA)
  cyan: '#277b80',        // was #5bc6cc (2.02:1 - failed AA)
  danger: '#943737',
  border: 'rgba(7,8,8,0.5)',
};
